<app-banner></app-banner>

<div class="container-fluid innerPageMenu">
    <div class="row">
        <div class="col-md-3">
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>Rules</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a routerLink="/rules/attendance"><i class="fa fa-angle-right" aria-hidden="true"></i>Attendance / Absents</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/rules/disciplinary"><i class="fa fa-angle-right" aria-hidden="true"></i>Disciplinary Measures</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/rules/punctuality"><i class="fa fa-angle-right" aria-hidden="true"></i>Punctuality</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/rules/late-comer"><i class="fa fa-angle-right" aria-hidden="true"></i>Late Comers</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/rules/damage"><i class="fa fa-angle-right" aria-hidden="true"></i>Damage to School Property</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/rules/library-rule"><i class="fa fa-angle-right" aria-hidden="true"></i>Library Rules</a>
                    </li>
                    <li routerLinkActive="active">
                        <a routerLink="/rules/slc"><i class="fa fa-angle-right" aria-hidden="true"></i>SLC Format</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="col-md-9">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>